import { render, staticRenderFns } from "./vpcoverview-header-actions.vue?vue&type=template&id=1d15cef9&scoped=true"
import script from "./vpcoverview-header-actions.ts?vue&type=script&lang=ts&external"
export * from "./vpcoverview-header-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./vpcoverview-header-actions.less?vue&type=style&index=0&id=1d15cef9&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d15cef9",
  null
  
)

export default component.exports